<script setup lang="ts" generic="T extends string">
// Le type de valeur reste générique pour que l'appelant garde sa sûreté de type
// (ex. useSpeciesSortOptions côté web).
export interface SortOption<V extends string> {
  label: string;
  value: V;
}

// Deux racines (USelect + annonce sr-only) : on route les attrs hérités (class…) vers le contrôle visible.
defineOptions({ inheritAttrs: false });

const props = defineProps<{
  options: SortOption<T>[];
}>();

const sort = defineModel<T>({ required: true });

const { t } = useI18n();

const currentLabel = computed(() => props.options.find((o) => o.value === sort.value)?.label ?? "");
const announcement = computed(() => t("ui.sort.announce", { label: currentLabel.value }));

// USelect n'unifie pas son inférence de value-key avec le T du composant : proxy `any` pour le
// seul v-model, le parent garde la sûreté de type via son propre ref typé.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectModel = computed<any>({
  get: () => sort.value,
  set: (v) => {
    if (v != null) sort.value = v as T;
  },
});
</script>

<template>
  <USelect v-bind="$attrs" v-model="selectModel" variant="link" :items="options" value-key="value" :content="{ align: 'end' }" class="w-auto">
    <template #default> {{ t("ui.sort.label") }} : {{ currentLabel }} </template>
  </USelect>
  <p role="status" class="sr-only">{{ announcement }}</p>
</template>
